import { render, staticRenderFns } from "./SignUp.vue?vue&type=template&id=528661d7&scoped=true&lang=pug&"
import script from "./SignUp.vue?vue&type=script&lang=ts&"
export * from "./SignUp.vue?vue&type=script&lang=ts&"
import style0 from "./SignUp.vue?vue&type=style&index=0&id=528661d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528661d7",
  null
  
)

component.options.__file = "SignUp.vue"
export default component.exports